import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69d9fbeaa749570014bfdf2f/onthegosafari/src/app/sign-up-login-screen/components/AuthScreen.tsx");
